module.exports = __webpack_public_path__ + "static/media/Dev_talks.b76d63af.jpg";